import { Stack } from 'expo-router';
import React from 'react';

function MyVaroLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default MyVaroLayout;
